"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateHasher = void 0;
const js_sha1_1 = require("js-sha1");
class StateHasher {
    static hash(obj) {
        return (0, js_sha1_1.sha1)(JSON.stringify(obj)).toString();
    }
}
exports.StateHasher = StateHasher;
